import { render, staticRenderFns } from "./myInvoice.vue?vue&type=template&id=e2ff08a4&scoped=true&"
import script from "./myInvoice.vue?vue&type=script&lang=js&"
export * from "./myInvoice.vue?vue&type=script&lang=js&"
import style0 from "./myInvoice.vue?vue&type=style&index=0&id=e2ff08a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ff08a4",
  null
  
)

export default component.exports